import * as FirebaseGet from "../../data/FirebaseGet";
import * as FirebasePush from "../../data/FirebasePush";
import {
  FETCH_TRANSLATION_MAP_REQUEST,
  FETCH_TRANSLATION_MAP_SUCCESS,
  FETCH_TRANSLATION_MAP_FAILURE,
  FETCH_RIGHTS_REQUEST,
  FETCH_RIGHTS_SUCCESS,
  FETCH_RIGHTS_FAILURE,
  FETCH_SUBRIGHTS_REQUEST,
  FETCH_SUBRIGHTS_SUCCESS,
  FETCH_SUBRIGHTS_FAILURE,
  FETCH_LEARNMORES_REQUEST,
  FETCH_LEARNMORES_SUCCESS,
  FETCH_LEARNMORES_FAILURE,
  ADD_OR_EDIT_RIGHTS_REQUEST,
  ADD_OR_EDIT_RIGHTS_SUCCESS,
  ADD_OR_EDIT_RIGHTS_FAILURE,
  SET_SELECTED_RIGHT_CATEGORY,
  SET_SELECTED_SUBRIGHT,
  FETCH_ORGS_REQUEST,
  FETCH_ORGS_SUCCESS,
  FETCH_ORGS_FAILURE,
} from "../../constants/ActionType";

/*
 * ==========
 * Actions
 * ==========
 */
const fetchTranslationMapRequest = () => ({
  type: FETCH_TRANSLATION_MAP_REQUEST,
});

const fetchTranslationMapSuccess = (translationMap) => ({
  type: FETCH_TRANSLATION_MAP_SUCCESS,
  payload: {
    translationMap,
  },
});

const fetchTranslationMapFailure = (errMessage) => ({
  type: FETCH_TRANSLATION_MAP_FAILURE,
  payload: {
    errMessage,
  },
});

const fetchOrgsRequest = () => ({
  type: FETCH_ORGS_REQUEST,
});

const fetchOrgsSuccess = (orgs) => ({
  type: FETCH_ORGS_SUCCESS,
  payload: {
    orgs,
  },
});

const fetchOrgsFailure = (errMessage) => ({
  type: FETCH_ORGS_FAILURE,
  payload: {
    errMessage,
  },
});

const fetchRightsRequest = () => ({
  type: FETCH_RIGHTS_REQUEST,
});

const fetchRightsSuccess = (rightsArr) => ({
  type: FETCH_RIGHTS_SUCCESS,
  payload: {
    rightsArr,
  },
});

const fetchRightsFailure = (errMessage) => ({
  type: FETCH_RIGHTS_FAILURE,
  payload: {
    errMessage,
  },
});

const fetchSubrightsRequest = () => ({
  type: FETCH_SUBRIGHTS_REQUEST,
});

const fetchSubrightsSuccess = (subrightsArr) => ({
  type: FETCH_SUBRIGHTS_SUCCESS,
  payload: {
    subrightsArr,
  },
});

const fetchSubrightsFailure = (errMessage) => ({
  type: FETCH_SUBRIGHTS_FAILURE,
  payload: {
    errMessage,
  },
});

const fetchLearnMoresRequest = () => ({
  type: FETCH_LEARNMORES_REQUEST,
});

const fetchLearnMoresSuccess = (learnMoresArr) => ({
  type: FETCH_LEARNMORES_SUCCESS,
  payload: {
    learnMoresArr,
  },
});

const fetchLearnMoresFailure = (errMessage) => ({
  type: FETCH_LEARNMORES_FAILURE,
  payload: {
    errMessage,
  },
});

const addOrEditRightRequest = () => ({
  type: ADD_OR_EDIT_RIGHTS_REQUEST,
});

const addOrEditRightSuccess = () => ({
  type: ADD_OR_EDIT_RIGHTS_SUCCESS,
});

const addOrEditRightFailure = (errMessage) => ({
  type: ADD_OR_EDIT_RIGHTS_FAILURE,
  payload: {
    errMessage: errMessage,
  },
});

export const setSelectedRightCategory = (rightCategory) => ({
  type: SET_SELECTED_RIGHT_CATEGORY,
  payload: {
    selectedRightCategory: rightCategory,
  },
});

export const setSelectedSubright = (subright) => ({
  type: SET_SELECTED_SUBRIGHT,
  payload: {
    selectedSubright: subright,
  },
});

/*
 * ==========
 * Dispatchers
 * ==========
 */

export const fetchTranslationMap = () => {
  return (dispatch) => {
    dispatch(fetchTranslationMapRequest());
    FirebaseGet.fetchTranslations()
      .then((translationMap) => {
        dispatch(fetchTranslationMapSuccess(translationMap));
      })
      .catch((error) => {
        dispatch(
          fetchTranslationMapFailure(
            "Failed obtaining data. Please reload the page to try again."
          )
        );
      });
  };
};

export const fetchOrgs = () => {
  return (dispatch) => {
    dispatch(fetchOrgsRequest());
    FirebaseGet.fetchOrgs()
      .then((orgs) => {
        dispatch(fetchOrgsSuccess(orgs));
      })
      .catch((error) => {
        dispatch(fetchOrgsFailure("Failed loading orgs."));
      });
  };
};

export const fetchRightsCategories = () => {
  return (dispatch) => {
    dispatch(fetchRightsRequest());
    FirebaseGet.fetchRightsCategoriesNew()
      .then((rightsCategories) => {
        dispatch(fetchRightsSuccess(rightsCategories));
      })
      .catch((error) => {
        dispatch(fetchRightsFailure("Error fetching rights categories."));
      });
  };
};

export const fetchSubrights = (rightsCategoryId) => {
  return (dispatch) => {
    dispatch(fetchSubrightsRequest());
    FirebaseGet.fetchSubrightsNew(rightsCategoryId)
      .then((subrights) => {
        dispatch(fetchSubrightsSuccess(subrights));
      })
      .catch((error) => {
        dispatch(
          fetchSubrightsFailure("There was an error getting the subrights")
        );
      });
  };
};

export const fetchLearnMores = (subrightID) => {
  return (dispatch) => {
    dispatch(fetchLearnMoresRequest());
    FirebaseGet.fetchLearnMoresNew(subrightID)
      .then((learnMores) => {
        dispatch(fetchLearnMoresSuccess(learnMores));
      })
      .catch((error) => {
        dispatch(
          fetchLearnMoresFailure("There was an error getting the learn mores.")
        );
      });
  };
};

export const editRightCategory = (
  newRightCategory,
  oldRightCategory,
  navigateFunction
) => {
  return (dispatch) => {
    dispatch(addOrEditRightRequest());
    FirebasePush.editRightCategoryNew(newRightCategory, oldRightCategory)
      .then(() => {
        dispatch(addOrEditRightSuccess());
        dispatch(fetchTranslationMapRequest());
        navigateFunction();
        FirebaseGet.fetchTranslations()
          .then((translationMap) => {
            dispatch(fetchTranslationMapSuccess(translationMap));
            dispatch(fetchRightsCategories());
          })
          .catch((error) => {
            dispatch(
              fetchTranslationMapFailure("Error fetching translations.")
            );
          });
      })
      .catch(() => {
        dispatch(addOrEditRightFailure("Internal Server Error"));
      });
  };
};

export const addRightCategory = (newRightCategory, navigateFunction) => {
  return (dispatch) => {
    dispatch(addOrEditRightSuccess());
    FirebasePush.pushNewRightCategoryNew(newRightCategory)
      .then(() => {
        dispatch(addOrEditRightSuccess());
        dispatch(fetchTranslationMapRequest());
        navigateFunction();
        FirebaseGet.fetchTranslations()
          .then((translationMap) => {
            dispatch(fetchTranslationMapSuccess(translationMap));
            dispatch(fetchRightsCategories());
          })
          .catch((error) => {
            dispatch(
              fetchTranslationMapFailure("Error fetching translations.")
            );
          });
      })
      .catch(() => {
        dispatch(addOrEditRightFailure("Internal Server Error"));
      });
  };
};

export const deleteRightCategory = (rightCategory, navigateFunction) => {
  return (dispatch) => {
    dispatch(addOrEditRightSuccess());
    FirebasePush.removeRightCategoryNew(rightCategory)
      .then(() => {
        dispatch(setSelectedRightCategory(null));
        dispatch(addOrEditRightSuccess());
        dispatch(fetchTranslationMapRequest());
        navigateFunction();
        FirebaseGet.fetchTranslations()
          .then((translationMap) => {
            dispatch(fetchTranslationMapSuccess(translationMap));
            dispatch(fetchRightsCategories());
          })
          .catch((error) => {
            dispatch(
              fetchTranslationMapFailure("Error fetching translations.")
            );
          });
      })
      .catch((error) => {
        dispatch(addOrEditRightFailure("Internal Server Error"));
      });
  };
};

export const editSubright = (newSubright, oldSubright, navigateFunction) => {
  return (dispatch) => {
    dispatch(addOrEditRightRequest());
    FirebasePush.editSubrightNew(newSubright, oldSubright)
      .then(() => {
        dispatch(addOrEditRightSuccess());
        dispatch(fetchTranslationMapRequest());
        navigateFunction();
        FirebaseGet.fetchTranslations()
          .then((translationMap) => {
            dispatch(fetchTranslationMapSuccess(translationMap));
            dispatch(fetchSubrights(newSubright.rightsCategoryID));
          })
          .catch((error) => {
            dispatch(
              fetchTranslationMapFailure("Error fetching translations.")
            );
          });
      })
      .catch((error) => {
        dispatch(addOrEditRightFailure("Internal Error."));
      });
  };
};

export const addSubright = (newSubright, navigateFunction) => {
  return (dispatch) => {
    dispatch(addOrEditRightRequest());
    FirebasePush.pushNewSubrightNew(newSubright).then(() => {
      dispatch(addOrEditRightSuccess());
      dispatch(fetchTranslationMapRequest());
      navigateFunction();
      FirebaseGet.fetchTranslations()
        .then((translationMap) => {
          dispatch(fetchTranslationMapSuccess(translationMap));
          dispatch(fetchSubrights(newSubright.rightsCategoryID));
        })
        .catch((error) => {
          dispatch(fetchTranslationMapFailure("Error fetching translations."));
        });
    });
    dispatch(addOrEditRightSuccess);
  };
};

export const deleteSubright = (subright, navigateFunction) => {
  return (dispatch) => {
    dispatch(addOrEditRightRequest());
    FirebasePush.removeSubrightNew(subright)
      .then(() => {
        dispatch(addOrEditRightSuccess());
        dispatch(fetchTranslationMapRequest());
        navigateFunction();
        FirebaseGet.fetchTranslations()
          .then((translationMap) => {
            dispatch(fetchTranslationMapSuccess(translationMap));
            dispatch(fetchSubrights(subright.rightsCategoryID));
          })
          .catch((error) => {
            dispatch(
              fetchTranslationMapFailure("Error fetching translations.")
            );
          });
      })
      .catch((error) => {
        dispatch(addOrEditRightFailure());
      });
  };
};

export const editLearnMore = (newLearnMore, oldLearnmore, navigateFunction) => {
  return (dispatch) => {
    dispatch(addOrEditRightRequest);
    FirebasePush.editLearnMoreNew(newLearnMore, oldLearnmore)
      .then(() => {
        dispatch(addOrEditRightSuccess());
        dispatch(fetchTranslationMapRequest());
        navigateFunction();
        FirebaseGet.fetchTranslations()
          .then((translationMap) => {
            dispatch(fetchTranslationMapSuccess(translationMap));
            dispatch(fetchLearnMores(newLearnMore.subrightID));
          })
          .catch((error) => {
            dispatch(
              fetchTranslationMapFailure("Error fetching translations.")
            );
          });
      })
      .catch((error) => {
        dispatch(addOrEditRightFailure("Internal Error."));
      });
  };
};

export const addLearnMore = (newLearnMore, navigateFunction) => {
  return (dispatch) => {
    dispatch(addOrEditRightRequest);
    FirebasePush.pushNewLearnMoreNew(newLearnMore)
      .then(() => {
        dispatch(addOrEditRightSuccess());
        dispatch(fetchTranslationMapRequest());
        navigateFunction();
        FirebaseGet.fetchTranslations()
          .then((translationMap) => {
            dispatch(fetchTranslationMapSuccess(translationMap));
            dispatch(fetchLearnMores(newLearnMore.subrightID));
          })
          .catch((error) => {
            dispatch(
              fetchTranslationMapFailure("Error fetching translations.")
            );
          });
      })
      .catch((error) => {
        dispatch(addOrEditRightFailure("Internal Error."));
      });
  };
};

export const deleteLearnMore = (
  learnMore,
  parentSubright,
  navigateFunction
) => {
  return (dispatch, getState) => {
    dispatch(addOrEditRightRequest());
    FirebasePush.removeLearnmoreNew(learnMore, parentSubright)
      .then(() => {
        dispatch(addOrEditRightSuccess());
        dispatch(fetchTranslationMapRequest());
        navigateFunction();
        FirebaseGet.fetchTranslations()
          .then((translationMap) => {
            dispatch(fetchTranslationMapSuccess(translationMap));
            const selectedRightCategory =
              getState().rights.selectedRightCategory;
            dispatch(fetchSubrights(selectedRightCategory.id));
            dispatch(fetchLearnMores(parentSubright.id));
          })
          .catch((error) => {
            dispatch(
              fetchTranslationMapFailure("Error fetching translations.")
            );
          });
      })
      .catch((error) => {
        dispatch(addOrEditRightFailure());
      });
  };
};
